'use strict';

angular.module('amexReconciliationApp')
  .service('SearchModel', function SearchModel(ModelFactory, 
                                               TransactionsModel,
                                               TransactionSearchModel,
                                               SiteConfigModel, 
                                               SearchRepository,
                                               UserPreferencesRepository,
                                               ExceptionNoteTranslationService,
                                               UserModel) {
    var searchModel = ModelFactory.create('SearchModel', ['activeSearch', 'results', 'savedSearches']);

    var isSearched = false;

    var FIELD_MAP = {
      'CARDMEMBER_NAME': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'cardmemberName');
        },
        dataType: 'dropdown',
        category: 'card'
      },
      'DESCRIPTION1': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.descriptionLine1');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'DESCRIPTION2': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.descriptionLine2');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'DESCRIPTION3': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.descriptionLine3');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'DESCRIPTION4': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.routing');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'MERCHANT_NAME': {
        matchFunction: merchantNameMatches,
        dataType: 'dropdown',
        category: 'merchant'
      },
      'EXCEPTION_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.exceptionFlag');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'LID_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'lineItemDetails.hasLineItems');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'CARDMEMBER_SUBMITTED_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.cardmemberSubmitted');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'CARD_MANAGER_APPROVED_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.cardManagerApproved');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'BCA_MANAGER_APPROVED_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.bcaManagerApproved');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'ACCOUNTING_MANAGER_APPROVED_FLAG': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.accountingManagerApproved');
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'CARDMEMBER_COMMENT': {
        matchFunction: commentsMatcher,
        dataType: 'boolean',
        category: 'userData'
      },
      'MANAGER_COMMENT': {
        matchFunction: commentsMatcher,
        dataType: 'boolean',
        category: 'userData'
      },
      'RECEIPT': {
        matchFunction: function(transaction, criterion)  {
          return matches(!_.isEmpty(transaction.receiptIds), criterion);
        },
        dataType: 'boolean',
        category: 'transaction'
      },
      'TRAVELER_NAME': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.travelerName');
        },
        dataType: 'string',
        category: 'travelData'
      },
      'CARDMEMBER_REFERENCE_1': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.cardmemberReference1');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'ROC_ID': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.ticketNumber');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'TICKET_NUMBER': {
        matchFunction: function(transaction, criterion)  {
          return transactionFieldMatches(transaction, criterion, 'details.ticketNumber');
        },
        dataType: 'string',
        category: 'travelData'
      },
      'PNR': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'transactionThirdPartyData[0].poNumber');
        },
        dataType: 'string',
        category: 'travelData'
      },
      'TRAVEL_DATA_FLAG': {
        matchFunction: function (transaction, criterion) {
          return matches(_.get(transaction, 'transactionThirdPartyData', []).length > 0, criterion);
        },
        dataType: 'boolean',
        category: 'travelData'
      },
      'BILLED_AMOUNT': {
        matchFunction: function(transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'amount');
        },
        dataType: 'number',
        category: 'transaction'
      },
      'SOURCE_AMOUNT': {
        matchFunction: function(transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'details.localAmount');
        },
        dataType: 'number',
        category: 'transaction'
      },
      'LOCK_STATUS': {
        matchFunction: lockStatusMatcher,
        dataType: 'lockStatus',
        category: 'transaction'
      },
      'TRANSACTION_STATUS': {
        matchFunction: transactionStatusMatcher,
        dataType: 'transactionStatus',
        category: 'transaction'
      },
      'SOURCE_CURRENCY': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'details.localCurrency');
        },
        dataType: 'string',
        category: 'transaction'
      },
      'EXCEPTION_TEXT': {
        matchFunction: exceptionTextMatcher,
        dataType: 'string',
        category: 'transaction'
      },
      'TRANSACTION_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'date');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'PROCESS_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'processDate');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'LAST_MODIFIED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'updatedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'CARDMEMBER_SUBMITTED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.cardmemberSubmittedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'CARD_MANAGER_APPROVED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.cardManagerApprovedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'BCA_MANAGER_APPROVED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.bcaManagerApprovedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'ACCOUNTING_MANAGER_APPROVED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'mutableTransactionProperties.accountingManagerApprovedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'REALLOCATED_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'allocations[0].updatedAt');
        },
        dataType: 'dateRange',
        category: 'date'
      },
      'PO_NUMBER': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'transactionThirdPartyData[0].poNumber');
        },
        dataType: 'string',
        category: 'po'
      },
      'REQUESTER_NAME': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'transactionThirdPartyData[0].requesterName');
        },
        dataType: 'string',
        category: 'po'
      },
      'BCA_NUMBER': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'bca');
        },
        dataType: 'string',
        category: 'card'
      },
      'MERCHANT_REFERENCE_NUMBER': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'details.merchantReference');
        },
        dataType: 'string',
        category: 'merchant'
      },
      'PREAUTH_FLAG': {
        matchFunction: function (transaction, criterion) {
          return matches(transaction.preAuthData.length > 0, criterion);
        },
        dataType: 'boolean',
        category: 'preauth'
      },
      'PREAUTH_UNIQUE_ID': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].id.preAuthorizationId');
        },
        dataType: 'string',
        category: 'preauth'
      },
      'PREAUTH_AMOUNT': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].preAuthorizationAmount');
        },
        dataType: 'number',
        category: 'preauth'
      },
      'PREAUTH_START_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].preAuthorizationStartDate');
        },
        dataType: 'dateRange',
        category: 'preauth'
      },
      'PREAUTH_END_DATE': {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].preAuthorizationEndDate');
        },
        dataType: 'dateRange',
        category: 'preauth'
      }
    };

    _.each(_.range(1, 4), function (number) {
      FIELD_MAP['PREAUTH_USER_DEFINED_FIELD_'+number] = {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].preAuthUserDefinedField'+number);
        },
        dataType: 'string',
        category: 'preauth'
      };
    });

    _.each(_.range(1, 9), function (number) {
      FIELD_MAP['PREAUTH_ACCOUNTING_FIELDS_'+number] = {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].ngAccountingField'+number);
        },
        dataType: 'string',
        category: 'preauth'
      };
    });

    _.each(_.range(1, 13), function (number) {
      FIELD_MAP['PREAUTH_CUSTOM_FIELDS_'+number] = {
        matchFunction: function (transaction, criterion) {
          return transactionFieldMatches(transaction, criterion, 'preAuthData[0].ngUserDefinedField'+number);
        },
        dataType: 'string',
        category: 'preauth'
      };
    });

    var FIELDS_FROM_BACKEND = {
      'ALLOCATION_DESCRIPTION': {category: 'accounting'},
      'MCC_CODE': {category: 'merchant'},
      'BCA_NAME': {category: 'card'},
      'BCA_DESCRIPTION': {category: 'card'},
      'CARDMEMBER_COMMENT_TEXT': {category: 'userData'},
      'MANAGER_COMMENT_TEXT': {category: 'userData'},
      'RECEIVER_NAME': {category: 'userData'},
      'RECEIVED_STATUS': {category: 'userData', dataType: 'receivedStatus'},
      'CARDMEMBER_SUBMITTED_BY': {category: 'transaction'},
      'CARD_MANAGER_APPROVED_BY': {category: 'transaction'},
      'BCA_MANAGER_APPROVED_BY': {category: 'transaction'},
      'ACCOUNTING_MANAGER_APPROVED_BY': {category: 'transaction'}
    };

    var OPERATOR_TYPES = {
      'STRING_EXACT': _.isEqual,
      'STRING_CONTAINS': _.includes,
      'STRING_NOT_CONTAINS': function(transactionValue, searchValue) {
        return !_.includes(transactionValue, searchValue);
      },
      'STRING_START': _.startsWith,
      'STRING_END': _.endsWith,
      'DATE_BETWEEN_INCLUSIVE': dateBetweenInclusiveOperation,
      'BOOLEAN': _.isEqual,
      'EQUALS': function(transactionValue, searchValue) {
        return transactionValue === searchValue;
      },
      'DOES_NOT_EQUAL': function(transactionValue, searchValue) {
        return transactionValue !== searchValue;
      },
      'GREATER_THAN_OR_EQUAL_TO': function(transactionValue, searchValue) {
        return transactionValue >= searchValue;
      },
      'GREATER_THAN': function(transactionValue, searchValue) {
        return transactionValue > searchValue;
      },
      'LESS_THAN_OR_EQUAL_TO': function(transactionValue, searchValue) {
        return transactionValue <= searchValue;
      },
      'LESS_THAN': function(transactionValue, searchValue) {
        return transactionValue < searchValue;
      }
    };

    var DEFAULT_OPERATORS = {
      'string' : 'STRING_CONTAINS',
      'dropdown' : 'STRING_EXACT',
      'boolean': 'BOOLEAN',
      'number' : 'EQUALS',
      'dateRange' : 'DATE_BETWEEN_INCLUSIVE'

    };

    var OPERATORS = {
      'string': ['STRING_EXACT', 'STRING_CONTAINS', 'STRING_NOT_CONTAINS', 'STRING_START', 'STRING_END'],
      'dropdown': ['STRING_EXACT', 'STRING_CONTAINS', 'STRING_NOT_CONTAINS', 'STRING_START', 'STRING_END'],
      'boolean': ['BOOLEAN'],
      'number' : ['EQUALS', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL_TO', 'LESS_THAN', 'LESS_THAN_OR_EQUAL_TO', 'DOES_NOT_EQUAL'],
      'dateRange': ['DATE_BETWEEN_INCLUSIVE']
    };

    searchModel.activeSearch({});

    searchModel.savedSearches([]);

    searchModel.searchCount = 0;

    searchModel.getFields = function () {
      var allFields = {};
      _.forEach(_.keys(FIELD_MAP), function(fieldName) {allFields[fieldName] = FIELD_MAP[fieldName];});
      var schemas = _.map(SiteConfigModel.getAccountingFieldSchemas(), function(schema) {return 'ACCOUNTING_FIELD_'+schema.position;});
      _.forEach(schemas, function(schema) {allFields[schema] = {category: 'accounting'};});
      _.forEach(_.keys(FIELDS_FROM_BACKEND), function(fieldName) {allFields[fieldName] = FIELDS_FROM_BACKEND[fieldName];});

      filterFields(allFields);

      return allFields;
    };

    searchModel.operators = function (criterion) {
      return OPERATORS[searchModel.getType(criterion)];
    };

    searchModel.search = function(search) {
      searchModel.results([]);
      var matchType = _.get(search, 'matchType');
      var frontEndCriteria = extractFrontEndFields(search.criteria);
      var backEndCriteria = extractBackEndFields(search.criteria);

      if (TransactionsModel.transactionCount() < TransactionsModel.maxTransactions()) {
        mixedSearch(search);
      } else {
        allBackEndSearch(search);
      }

      searchModel.activeSearch(search);
    };

    searchModel.isSearched = function() {
      return isSearched;
    };
    
    searchModel.getType = function(criterion) {
      var field = FIELD_MAP[criterion.fieldType];
      if (field) {
        return field.dataType;
      } else {
        var backendField = FIELDS_FROM_BACKEND[criterion.fieldType];
        if (backendField && backendField.dataType) {
          return backendField.dataType;
        }
      }
      if (criterion.fieldType) {
        return 'string';
      } else {
        return '';
      }
    };

    searchModel.deleteSavedSearch = function (search) {
      _.pull(searchModel.savedSearches(), search);
      updateSavedSearches();
    };
    
    searchModel.saveSearch = function (search) {
      var index = _.findIndex(searchModel.savedSearches(), {name: search.name});
      if (index > -1) {
        searchModel.savedSearches().splice(index, 1, _.cloneDeep(search));
      } else {
        searchModel.savedSearches().push(_.cloneDeep(search));
      }
      updateSavedSearches();
    };

    searchModel.mergeResultSets = function (matchType, frontEndResultSet, backEndResultSet) {
      var mergeFunctions = {
        'ALL': _.intersection,
        'ANY': _.union
      };
      return mergeFunctions[matchType](frontEndResultSet, backEndResultSet);
    };

    searchModel.updateCriterion = function(criterion) {
      criterion.operator = checkOperatorType(criterion);

      if (criterion.fieldValue === undefined) {
        criterion.fieldValue = {};
      }

      switch (searchModel.getType(criterion)) {
        case 'boolean':
          criterion.fieldValue.type = 'boolean';
          criterion.fieldValue.value = true;
          break;
        case 'string':
          criterion.fieldValue.type = 'string';
          criterion.fieldValue.value = '';
          break;
        case 'dropdown':
          criterion.fieldValue.type = 'string';
          criterion.fieldValue.value = '';
          criterion.operator = DEFAULT_OPERATORS['dropdown'];
          break;
        case 'number':
          criterion.fieldValue.type = 'number';
          criterion.fieldValue.value = '';
          break;
        case 'dateRange':
          criterion.fieldValue.type = 'dateRange';
          criterion.fieldValue.from = convertToLocalTime(TransactionSearchModel.billingCycle().startDate);
          criterion.fieldValue.to = convertToLocalTime(TransactionSearchModel.billingCycle().endDate);
          break;
        case 'receivedStatus':
        case 'lockStatus':
        case 'transactionStatus':
          criterion.fieldValue.type = 'list';
          criterion.fieldValue.values = [];
          break;
      }
    };

    searchModel.closeSearch = function () {
      isSearched = false;
    };

    searchModel.allBackEndSearchCount = function(search) {

      var parameters = {
        matchType: search.matchType,
        criteria: search.criteria
      };

      return SearchRepository.searchCount(parameters)
        .then(function(countResponse) {
          searchModel.searchCount = countResponse.numberOfTransactions;
        });

    };

    function backEndSearch(search) {
      TransactionsModel.loading(true);
      return SearchRepository.searchForIds(
        {
          matchType: search.matchType,
          criteria: extractBackEndFields(search.criteria)
        }
      );
    }

    function allBackEndSearch(search) {
      TransactionsModel.loading(true);

      var parameters = {
        matchType: search.matchType,
        criteria: search.criteria
      };

      SearchRepository.searchCount(parameters)
        .then(function(countResponse) {
          searchModel.searchCount = countResponse.numberOfTransactions;
          if (countResponse.numberOfTransactions < TransactionsModel.maxTransactions()) {
            SearchRepository.search(parameters)
              .then(function(searchResponse) {
                searchModel.results(searchResponse);
                TransactionsModel.transactions(searchResponse);
                isSearched = true;
                TransactionsModel.loading(false);
              });
          } else {
            TransactionsModel.loading(false);
          }
        });
    }

    function frontEndSearchAny(criteria, resultSet) {
      _.forEach(criteria, function (criterion) {

        resultSet = _.union(resultSet, _.filter(TransactionsModel.transactions(), function (transaction) {
          return FIELD_MAP[criterion.fieldType].matchFunction(transaction, criterion);
        }));

      });
      return resultSet;
    }

    function frontEndSearchAll(criteria, resultSet) {
      resultSet = TransactionsModel.transactions();
      _.forEach(criteria, function (criterion) {
        resultSet = _.filter(resultSet, function (transaction) {
          return FIELD_MAP[criterion.fieldType].matchFunction(transaction, criterion);
        });
      });
      return resultSet;
    }

    function frontEndSearch(search) {
      var criteria = extractFrontEndFields(search.criteria);
      var matchType = _.get(search, 'matchType', 'ALL');
      var resultSet = [];
      
      var searchFunctions = {
        'ALL': frontEndSearchAll, 
        'ANY': frontEndSearchAny
      };

      return _.map(searchFunctions[matchType](criteria, resultSet), 'id');
    }

    function mixedSearch(search) {
      searchModel.results([]);
      var matchType = _.get(search, 'matchType');
      var frontEndCriteria = extractFrontEndFields(search.criteria);
      var backEndCriteria = extractBackEndFields(search.criteria);

      var frontEndSearchResults;
      if(frontEndCriteria.length > 0) {
        frontEndSearchResults = frontEndSearch(search);
      }

      var backEndSearchResults;
      if(backEndCriteria.length > 0) {
        backEndSearch(search).then(function (results) {
          backEndSearchResults = results;
        }).finally(function() {
          if (frontEndSearchResults) {
            searchModel.results(searchModel.mergeResultSets(matchType, frontEndSearchResults, backEndSearchResults));
          } else {
            searchModel.results(backEndSearchResults);
          }
          isSearched = true;
          TransactionsModel.loading(false);
        });
      } else {
        searchModel.results(frontEndSearchResults);
        isSearched = true;
      }
    }

    function transactionFieldMatches(transaction, criterion, fieldPath) {
      var transactionValue = _.get(transaction, fieldPath, '');
      return matches(transactionValue, criterion);
    }

    function commentsMatcher(transaction, criterion)  {
      var commentIndicator = _.get(transaction, 'mutableTransactionProperties.commentIndicator');
      var hasComments = commentIndicator === criterion.fieldType || commentIndicator === 'BOTH';

      return criterion.fieldValue.value ? hasComments : !hasComments;
    }

    function exceptionTextMatcher(transaction, criterion) {
      if(transaction.details.exceptionNote) {
        var translatedExceptionText = ExceptionNoteTranslationService.translateExceptionNote(transaction.details.exceptionNote);
        return matches(translatedExceptionText, criterion);
      }

      return false;
    }

    function lockStatusMatcher(transaction, criterion)  {
      var lockStatus = _.get(transaction, 'lockStatus');
      var heldIndicator = _.get(transaction, 'transactionHold.hold');

      return _.some(criterion.fieldValue.values, function(fieldValue) {
        if (fieldValue === 'HELD') {
          return heldIndicator;
        } else {
          return lockStatus === fieldValue;
        }
      });
    }

    function transactionStatusMatcher(transaction, criterion)  {
      var transactionStatus = _.get(transaction, 'mutableTransactionProperties.transactionStatus');

      return _.some(criterion.fieldValue.values, function(fieldValue) {
        return transactionStatus === fieldValue;
      });
    }

    function matches(transactionValue, criterion) {
      var dataType = searchModel.getType(criterion);
      var fieldValue;
      
      switch (dataType) {
        case 'string':
        case 'dropdown':
          fieldValue = _.toUpper(criterion.fieldValue.value);
          transactionValue = _.toUpper(transactionValue);
          break;
        case 'boolean':
          fieldValue = criterion.fieldValue.value;
          break;
        case 'number':
          fieldValue = parseFloat(criterion.fieldValue.value);
          break;
        case 'dateRange':
          fieldValue = criterion.fieldValue;
          break;
      }

      // if Contains option with empty value, use exact search to get empty list.
      if( criterion.operator === 'STRING_CONTAINS' && fieldValue === '' ) {
        return OPERATOR_TYPES['STRING_EXACT'](transactionValue, fieldValue);
      }

      return OPERATOR_TYPES[criterion.operator](transactionValue, fieldValue);
    }

    function dateBetweenInclusiveOperation(transactionValue, searchValue) {
      var from, to;
      if (!searchValue.from) {
        from = moment(convertToLocalTime(TransactionSearchModel.billingCycle().startDate));
      } else {
        from = moment(searchValue.from);
      }

      if (!searchValue.to) {
        to = moment(convertToLocalTime(TransactionSearchModel.billingCycle().endDate));
      } else {
        to = moment(searchValue.to);
      }

      var transactionDate = moment(new Date(transactionValue)).utc();

      return transactionDate.isValid() && transactionDate.isBetween(from, to, 'days', '[]');
    }

    function merchantNameMatches(transaction, criterion) {

      return transactionFieldMatches(transaction, criterion, 'merchantName2') ||
        transactionFieldMatches(transaction, criterion, 'merchantName');
    }

    function extractFrontEndFields (criteria) {
      return _.filter(criteria, function(criterion) {
        return FIELD_MAP[criterion.fieldType];
      });
    }

    function extractBackEndFields (criteria) {
      return _.filter(criteria, function(criterion) {
        return !FIELD_MAP[criterion.fieldType];
      });
    }

    function checkOperatorType(criterion) {
      var operator = criterion.operator;
      var dataType = searchModel.getType(criterion);

      if ( !_.includes(OPERATORS[dataType], operator) ) {
        operator = DEFAULT_OPERATORS[dataType];
      }
      return operator;
    }

    function updateSavedSearches () {
      var userPreferences = UserModel.currentUserPreferences();
      userPreferences.searches = searchModel.savedSearches();

      UserPreferencesRepository.save(userPreferences)
        .then(function () {
          UserModel.currentUser().preferredSearches = searchModel.savedSearches();
        });
    }

    searchModel.loadDefaultSearches = function () {
      searchModel.savedSearches(UserModel.currentUser().preferredSearches);
    };

    searchModel.cloneSearch = function (search) {
      _.map(search.criteria, function (criterion) {
        if (_.isEqual(_.get(criterion, 'fieldValue.type'), 'dateRange')) {
          var processedFromDate = convertToLocalTime(_.get(criterion, 'fieldValue.from'));
          var processedToDate = convertToLocalTime(_.get(criterion, 'fieldValue.to'));

          _.set(criterion, 'fieldValue.from', processedFromDate);
          _.set(criterion, 'fieldValue.to', processedToDate);
        }
      });
      return _.cloneDeep(search);
    };

    var convertToLocalTime = function(date) {
      try {
        return new Date(date.replace(/-/g, '\/').replace(/T.+/, ''));
      } catch (error) {
        return date;
      }
    };

    var filterFields = function(allFields) {
      var fieldNamesToRemove = [];

      if (TransactionSearchModel.isCardManager() || TransactionSearchModel.isCardMember()) {
        fieldNamesToRemove = fieldNamesToRemove.concat('CARDMEMBER_NAME');
      }

      if (!(SiteConfigModel.isBta() || SiteConfigModel.isVngBtaProductType())) {
        fieldNamesToRemove = fieldNamesToRemove.concat(getFieldNamesToRemoveByCategory(allFields,'travelData'));
      }

      if (!SiteConfigModel.isPreAuth()) {
        fieldNamesToRemove = fieldNamesToRemove.concat(getFieldNamesToRemoveByCategory(allFields, 'preauth'));
      }

      if (!SiteConfigModel.isPo()) {
        fieldNamesToRemove = fieldNamesToRemove.concat(getFieldNamesToRemoveByCategory(allFields,'po'));
      }

      _.map(fieldNamesToRemove,function(fieldName) {delete allFields[fieldName];});
    };

    var getFieldNamesToRemoveByCategory = function(allFields, category) {
      var fieldNames = _.keys(allFields);
      var namesToRemove = [];
      _.map(fieldNames, function(name) {
        if (allFields[name]['category'] === category) {
          namesToRemove.push(name);
        }
      });
      return namesToRemove;
    };
    

    return searchModel;
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/SearchModel.js
// module id = 585
// module chunks = 0